module.exports = __webpack_public_path__ + "img/viking-logo-white-cropped.d016fcc3.svg";